export default __webpack_public_path__ + "static/media/pot2.1f2a5f0a.jpg";